import React from 'react';
import { useSnackbar } from 'notistack';
import defaultLocales from 'globals/locales/default';
import FsInviteNewUserForm from 'ui-elements/forms/FsInviteNewUserForm';
import FsButton from 'ui-elements/buttons/FsButton';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsConfirmationDialog from 'ui-elements/modals/FsConfirmationDialog';
import FsDefaultDialog from 'ui-elements/modals/FsDefaultDialog';
import { OnSuccessProps } from 'ui-elements/forms/FsInviteNewUserForm/FsInviteNewUserForm';
import { useMediaQuery, useTheme } from '@material-ui/core';

const isTwoStepConfirmation = true;

interface FsAddNewUserModalProps {
  onClose: () => void;
}

const FsAddNewUserModal: React.FC<FsAddNewUserModalProps> = ({ onClose }) => {
  const [stepIdx, setStepIdx] = React.useState<number>(0);
  const [email, setEmail] = React.useState<string>('');
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });

  const handleConfirmation = () => {
    if (stepIdx <= 0 || (isTwoStepConfirmation && stepIdx <= 1)) {
      setStepIdx((currentIdx) => currentIdx + 1);
      return;
    }
    enqueueSnackbar(defaultLocales.invitationSendNotificationSuccess, {
      variant: 'success',
    });
    onClose();
  };

  const handleFromSuccess = ({ email: emailAddress }: OnSuccessProps) => {
    setEmail(emailAddress);
    handleConfirmation();
  };

  return (
    <>
      <FsDefaultDialog
        disableBackdropClick
        disableEscapeKeyDown
        title={defaultLocales.inviteTeammate}
        isOpen={stepIdx === 0}
        fullWidth
        maxWidth="xs"
        onClose={onClose}
      >
        <FsInviteNewUserForm onSuccess={handleFromSuccess} />
      </FsDefaultDialog>

      <FsConfirmationDialog
        title={defaultLocales.confirmEmail}
        showModal={stepIdx === 1}
        setShowModal={onClose}
        actionButtons={[
          <FsButton key={1} onClick={onClose}>
            {defaultLocales.no}
          </FsButton>,
          <FsButton
            key={2}
            onClick={handleConfirmation}
            variant="contained"
            color="primary"
          >
            {isUpSm
              ? `${defaultLocales.yes}, ${defaultLocales.iConfirm}`
              : `${defaultLocales.iConfirm}`}
          </FsButton>,
        ]}
      >
        <FsBody>
          {defaultLocales.sendInvitationEmailQuestion}{' '}
          <FsBodyBold component="span">{email}</FsBodyBold>?
        </FsBody>
      </FsConfirmationDialog>

      <FsConfirmationDialog
        title={defaultLocales.confirmDomain}
        showModal={stepIdx === 2}
        setShowModal={onClose}
        actionButtons={[
          <FsButton key={1} onClick={onClose}>
            {defaultLocales.no}
          </FsButton>,
          <FsButton
            key={2}
            onClick={handleConfirmation}
            variant="contained"
            color="primary"
          >
            {isUpSm
              ? `${defaultLocales.yes}, ${defaultLocales.iConfirm}`
              : `${defaultLocales.iConfirm}`}
          </FsButton>,
        ]}
      >
        <FsBody>{defaultLocales.sendInvitationDomainQuestion}</FsBody>
      </FsConfirmationDialog>
    </>
  );
};

export default FsAddNewUserModal;
